/**
 * Autorização do checkout com meta (dono, 20/10/2026) — espelho de `Dashboard/shared/texto-da-condicao.ts` (o site
 * não importa o shared do app). O guard `Dashboard/server/payments/meta-de-lotes/rotas.test.ts` (no `npm test` do
 * Dashboard) e o teste `testes/condicao-em-blocos.test.tsx` conferem que os dois são iguais.
 *
 * O checkbox mostra só a frase curta; "condições da oferta" leva à condição, no rodapé da página. O texto ENVIADO
 * (e gravado com hash pelo servidor) é a frase curta + a condição achatada inteira: o servidor só abre a compra se o
 * aceite contém a condição atual.
 */

/** As partes da frase curta: o trecho do meio vira o link para a condição na tela. */
export const PARTES_DA_AUTORIZACAO_CURTA = {
  antes: "Autorizo a cobrança recorrente no cartão informado, quando aplicável, conforme as ",
  link: "condições da oferta",
  depois: ".",
} as const;

/** A frase curta do checkbox, inteira. */
export const AUTORIZACAO_CURTA = `${PARTES_DA_AUTORIZACAO_CURTA.antes}${PARTES_DA_AUTORIZACAO_CURTA.link}${PARTES_DA_AUTORIZACAO_CURTA.depois}`;

/** O que o checkout envia: a frase curta seguida da condição achatada. */
export function autorizacaoComCondicao(condicao: string): string {
  return `${AUTORIZACAO_CURTA} Condições da oferta: ${condicao}`;
}

/** Onde a condição fica na página do escritório (o rodapé recolhível). */
export const ID_DAS_CONDICOES = "condicoes-da-oferta";
